<template>
  <div class="generic-search-list-sidebar">
    <simple-list
      id="genericCode"
      ref="genericCode"
      :server-items="items"
      query="$and.0.category"
      :undefined-value="allLabel"
      class="req"
      variant="generic-search"
      internal-scroll
      :height="listHeight"
      @item-update="$emit('get-focusable-elements')"
      @mounted="$emit('update-focusable')"
    >
      <template #filter>
        <div
          ref="genericListHeader"
          class="generic-list-header"
        >
          <generic-list-search-bar @filter-items="filterItems" />
          <generic-list-categories
            :categories="categories"
            @filter-items="filterItems"
          />
        </div>
      </template>
      <template #rendered-list="{ items: filteredItems }">
        <ul>
          <li
            v-for="item in filteredItems"
            :key="item.id"
          >
            <generic-list-card
              :item="item"
              :search-input="inputString"
              :query-changed="queryChanged"
              :is-loading="isLoading"
            />
          </li>
        </ul>
      </template>
    </simple-list>
    <loading-dots />
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { GenericListSearchBar, GenericListCategories, GenericListCard } from './components'

  export default {
    name: 'GenericList',
    components: {
      GenericListSearchBar,
      GenericListCategories,
      GenericListCard,
    },
    inject: ['allLabel'],
    props: {
      deactivate: {
        type: Function,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      }
    },
    data: () => ({
      isLoading: false,
      listHeight: null,
      inputString: '',
      inputValue: { $exists: true },
      tabValue: { $exists: true },
      queryChanged: -1,
      categories: []
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('responsive', { wHeight: 'height' }),
    },
    watch: {
      wHeight() {
        this.calculateListHeight()
      }
    },
    mounted() {
      this.calculateListHeight()
      this.configureCategoriesList()
      this.$emit('update-focusable')
    },
    methods: {
      configureCategoriesList() {
        this.items.forEach((item) => {
          if (!this.categories.includes(item.category)) {
            this.categories.push(item.category)
          }
        })
      },
      calculateListHeight() {
        const modalHeaderHeight = document.querySelector('.modal-header').getBoundingClientRect().height
        const listHeaderHeight = this.$refs.genericListHeader.clientHeight
        this.listHeight = this.wHeight - listHeaderHeight - modalHeaderHeight
      },
      closeModal() {
        this.deactivate()
      },
      async filterItems(value, type) {
        if (type === 'input') {
          if (value) {
            this.inputValue = { $regex: `${value}`, $options: 'i' }
            this.inputString = value
          } else {
            this.inputValue = { $exists: true }
            this.inputString = ''
          }
        }
        if (type === 'tab') {
          if (value) {
            this.tabValue = value
          } else {
            this.tabValue = { $exists: true }
          }
        }
        const searchFilter = {
          $and: [
            {
              category: this.tabValue
            },
            {
              $or: [
                { label: this.inputValue },
                { shortDescription: this.inputValue },
              ]
            }
          ]
        }
        await this.$refs.genericCode.updateFilter(searchFilter)
        this.queryChanged += 1
        this.$emit('get-focusable-elements')
      },
    },
  }
</script>
